import React from "react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlayersStatisticsTableRowMemberRowViewModel} from "../../../../domain/yard/lineups/players-statistics/tables/rows/member/players-statistics.table.row.member-row.view-model";
import {BoxScoresWidgetRowPrimaryCellsMember} from "./box-scores-widget.row-primary-cells.member";
import {BoxScoresWidgetController} from "../../box-scores-widget.controller";

class BoxScoresWidgetRowPrimaryCellsMembersProps extends BaseProps {
  rows: Array<PlayersStatisticsTableRowMemberRowViewModel>;
  controller: BoxScoresWidgetController;
}

export const BoxScoresWidgetRowPrimaryCellsMembers = (({controller, rows}: BoxScoresWidgetRowPrimaryCellsMembersProps) => {
  return (
    <>
      {
        rows.map(row => <BoxScoresWidgetRowPrimaryCellsMember member={row.member} key={row.member.id} controller={controller}/>)
      }
    </>
  )
});
